export const PureProfileFavIcons = [
  {
    rel: 'shortcut icon',
    href: 'favicon1.png?v=1'
  }
];